import {
  db,
  Admintables,
  BHUtables,
  RHCtables,
  XpertSitetables,
  Ridertables,
  DistrictFieldSupervisortables,
} from '../../db'
import * as Common from '../CommonControlls/CommonJs'
import $ from 'jquery'

// Roles
export function SelectAllRoles(success_callback, error_callback) {
  db.Roles.orderBy('id')
    .reverse()
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}

// Riders
export function SelectAllRiders(success_callback, error_callback) {
  db.Riders.orderBy('id')
    .reverse()
    .filter(function (Obj) {
      return Obj.isApproved
    })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}

export function SelectAllBanks(success_callback, error_callback) {
  db.Banks.orderBy('id')
    .reverse()
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}

export function SelectPageLastSearch(
  pageName,
  success_callback,
  error_callback,
) {
  db.ListSearchHistory.get({ pageName: pageName })
    .then((obj) => {
      if (obj === undefined) {
        success_callback({ status: false })
      } else {
        success_callback({ status: true, data: $.parseJSON(obj.searchInfo) })
      }
    })
    .catch(function (e) {
      error_callback(e)
    })
}

// Province
export function SelectProvince(id, success_callback, error_callback) {
  db.Province.get({ id: id })
    .then((obj) => {
      success_callback(obj)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectProvinceList(
  SearchParm,
  Pagination,
  success_callback,
  error_callback,
) {
  db.Province.filter(function (Obj) {
    return (
      Common.isEmptyUndef(SearchParm.name) ||
      Obj.name.toLowerCase().includes(SearchParm.name.toLowerCase())
    )
  })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
      // var TotalRecord= Datalist.length
      // success_callback(Common.paginate(Datalist, Pagination.pageSize, Pagination.pageNumber),TotalRecord)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectAllProvince(success_callback, error_callback) {
  db.Province.orderBy('id')
    .reverse()
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}

// District
export function SelectAllDistricts(
  roleId,
  srDistrictIds,
  success_callback,
  error_callback,
) {
  var tempIdString =
    roleId === 8 ? (srDistrictIds == null ? ',0,' : srDistrictIds) : ',0,'
  db.District.orderBy('id')
    .reverse()
    .filter(function (Obj) {
      return roleId === 8 ? tempIdString.includes(',' + Obj.id + ',') : true
    })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectCompleteDistrictsList(success_callback, error_callback) {
  db.District.orderBy('id')
    .reverse()
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectDistrictsList(
  SearchParm,
  Pagination,
  success_callback,
  error_callback,
) {
  db.District.filter(function (Obj) {
    return (
      (Common.isEmptyUndef(SearchParm.name) ||
        Obj.name.toLowerCase().includes(SearchParm.name.toLowerCase())) &&
      (SearchParm.provinceId == 0 || SearchParm.provinceId == Obj.provinceId)
    )
  })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
      // var TotalRecord= Datalist.length
      // success_callback(Common.paginate(Datalist, Pagination.pageSize, Pagination.pageNumber),TotalRecord)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectDistrict(id, success_callback, error_callback) {
  db.District.get({ id: id })
    .then((obj) => {
      success_callback(obj)
    })
    .catch(function (e) {
      error_callback(e)
    })
}

// Tehsil
export function SelectAllTehsils(success_callback, error_callback) {
  db.Tehsil.orderBy('id')
    .reverse()
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectTehsilsList(
  SearchParm,
  Pagination,
  success_callback,
  error_callback,
) {
  db.Tehsil.filter(function (Obj) {
    return (
      (Common.isEmptyUndef(SearchParm.name) ||
        Obj.name.toLowerCase().includes(SearchParm.name.toLowerCase())) &&
      (SearchParm.provinceId == 0 || SearchParm.provinceId == Obj.provinceId) &&
      (SearchParm.districtId == 0 || SearchParm.districtId == Obj.districtId)
    )
  })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
      // var TotalRecord= Datalist.length
      // success_callback(Common.paginate(Datalist, Pagination.pageSize, Pagination.pageNumber),TotalRecord)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectTehsil(id, success_callback, error_callback) {
  db.Tehsil.get({ id: id })
    .then((obj) => {
      success_callback(obj)
    })
    .catch(function (e) {
      error_callback(e)
    })
}

//Xpert Site
export function SelectAllXpertSites(success_callback, error_callback) {
  db.XpertSite.orderBy('id')
    .reverse()
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectXpertSiteList(
  roleId,
  srDistrictIds,
  SearchParm,
  Pagination,
  success_callback,
  error_callback,
) {
  var tempIdString =
    roleId == 8 ? (srDistrictIds == null ? ',0,' : srDistrictIds) : ',0,'
  db.XpertSite.filter(function (Obj) {
    return (
      (Common.isEmptyUndef(SearchParm.name) ||
        Obj.name.toLowerCase().includes(SearchParm.name.toLowerCase())) &&
      (SearchParm.provinceId == 0 || Obj.provinceId == SearchParm.provinceId) &&
      (SearchParm.districtId == 0 || SearchParm.districtId == Obj.districtId) &&
      (SearchParm.tehsilId == 0 || SearchParm.tehsilId == Obj.tehsilId) &&
      (roleId == 8 ? tempIdString.includes(',' + Obj.districtId + ',') : true)
    )
  })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
      // var TotalRecord= Datalist.length
      // success_callback(Common.paginate(Datalist, Pagination.pageSize, Pagination.pageNumber),TotalRecord)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectXpertSite(id, success_callback, error_callback) {
  db.XpertSite.get({ id: id })
    .then((obj) => {
      success_callback(obj)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectDistrictFilteredXpertSite(
  roleId,
  srDistrictIds,
  success_callback,
  error_callback,
) {
  var tempIdString =
    roleId == 8 ? (srDistrictIds == null ? ',0,' : srDistrictIds) : ',0,'
  db.XpertSite.orderBy('id')
    .reverse()
    .filter(function (Obj) {
      return roleId == 8
        ? tempIdString.includes(',' + Obj.districtId + ',')
        : true
    })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}

// HCF
export function SelectAllHCF(success_callback, error_callback) {
  db.HCF.orderBy('id')
    .reverse()
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectHCFList(
  roleId,
  srDistrictIds,
  SearchParm,
  Pagination,
  success_callback,
  error_callback,
) {
  var tempIdString =
    roleId == 8 ? (srDistrictIds == null ? ',0,' : srDistrictIds) : ',0,'
  db.HCF.filter(function (Obj) {
    return (
      (Common.isEmptyUndef(SearchParm.name) ||
        Obj.name.toLowerCase().includes(SearchParm.name.toLowerCase())) &&
      (SearchParm.provinceId == 0 || Obj.provinceId == SearchParm.provinceId) &&
      (SearchParm.districtId == 0 || SearchParm.districtId == Obj.districtId) &&
      (SearchParm.tehsilId == 0 || SearchParm.tehsilId == Obj.tehsilId) &&
      (SearchParm.typeId == 0 || SearchParm.typeId == Obj.typeId) &&
      (roleId == 8 ? tempIdString.includes(',' + Obj.districtId + ',') : true)
    )
  })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
      // var TotalRecord= Datalist.length
      // success_callback(Common.paginate(Datalist, Pagination.pageSize, Pagination.pageNumber),TotalRecord)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectHCF(id, success_callback, error_callback) {
  db.HCF.get({ id: id })
    .then((obj) => {
      success_callback(obj)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectDistrictFilteredHCF(
  roleId,
  srDistrictIds,
  success_callback,
  error_callback,
) {
  var tempIdString =
    roleId == 8 ? (srDistrictIds == null ? ',0,' : srDistrictIds) : ',0,'
  db.HCF.orderBy('id')
    .reverse()
    .filter(function (Obj) {
      return roleId == 8
        ? tempIdString.includes(',' + Obj.districtId + ',')
        : true
    })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}

//Settings
export function SelectSettings(success_callback, error_callback) {
  db.Settings.get({ id: 1 })
    .then((obj) => {
      success_callback(obj)
    })
    .catch(function (e) {
      error_callback(e)
    })
}

// Patients
export function SelectAllPatients(success_callback, error_callback) {
  db.Patients.orderBy('id')
    .reverse()
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectPatientsList(
  SearchParm,
  Pagination,
  success_callback,
  error_callback,
) {
  db.Patients.filter((Obj) => {
    return (
      (Common.isEmptyUndef(SearchParm.name) ||
        Obj.name.toLowerCase().includes(SearchParm.name.toLowerCase())) &&
      (Common.isEmptyUndef(SearchParm.contact) ||
        Obj.contact.toLowerCase().includes(SearchParm.contact.toLowerCase())) &&
      new Date(Common.ConvertToLocalDateTime(Obj.creationDateTime)) >=
        SearchParm.fromDate &&
      new Date(Common.ConvertToLocalDateTime(Obj.creationDateTime)) <=
        SearchParm.toDate &&
      SearchParm.hcfId == Obj.hcfId
    )
  })
    .toArray()
    .then((Datalist) => {
      if (SearchParm.sortOrder == 'asc') {
        Datalist = Datalist.sort((a, b) => {
          if (a[SearchParm.sortField] > b[SearchParm.sortField]) {
            return 1
          } else if (b[SearchParm.sortField] > a[SearchParm.sortField]) {
            return -1
          }
          return 0
        })
      } else {
        Datalist = Datalist.sort((a, b) => {
          if (a[SearchParm.sortField] > b[SearchParm.sortField]) {
            return -1
          } else if (b[SearchParm.sortField] > a[SearchParm.sortField]) {
            return 1
          }
          return 0
        })
      }
      var TotalRecord = Datalist.length
      success_callback(
        Common.paginate(Datalist, Pagination.pageSize, Pagination.pageNumber),
        TotalRecord,
      )
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectPatient(id, success_callback, error_callback) {
  console.log('db', db.Patients)
  console.log('db', id)
  db.Patients.get({ id: id })
    .then((obj) => {
      console.log('obj', obj)
      success_callback(obj)
    })
    .catch(function (e) {
      console.log('e', e)
      error_callback(e)
    })
}
export function SearchPatient(
  keyword,
  hcfId,
  success_callback,
  error_callback,
) {
  db.Patients.filter(function (Obj) {
    return hcfId == Obj.hcfId
  })
    .toArray()
    .then((Datalist) => {
      var TotalRecord = Datalist.length
      var filterPatient = []
      for (var i = 0; i < TotalRecord; i++) {
        if (filterPatient.length >= 50) {
          success_callback(filterPatient)
          return
        }
        if (
          Datalist[i].name.toLowerCase().includes(keyword.toLowerCase()) ||
          Datalist[i].contact.toLowerCase().includes(keyword.toLowerCase())
        ) {
          var temp = Datalist[i]
          filterPatient.push(temp)
        }
      }
      success_callback(filterPatient)
      return
    })
    .catch((e) => {
      error_callback(e)
    })
}

// Patient Samples
export function SelectPatientSamplesList(
  SearchParm,
  Pagination,
  success_callback,
  error_callback,
) {
  if (SearchParm.RoleId == 6) {
    db.PatientSamples.filter(function (Obj) {
      return (
        Obj.isSubmitted &&
        (Common.isEmptyUndef(SearchParm.Id) || Obj.id == SearchParm.Id) &&
        SearchParm.hcfId == Obj.hfcId &&
        new Date(Common.ConvertToLocalDateTime(Obj.sampleDateTime)) >=
          SearchParm.fromDate &&
        new Date(Common.ConvertToLocalDateTime(Obj.sampleDateTime)) <=
          SearchParm.toDate
      )
    })
      .toArray()
      .then((Datalist) => {
        success_callback(Datalist)
      })
      .catch(function (e) {
        error_callback(e)
      })
  } else {
    db.PatientSamples.filter(function (Obj) {
      return (
        Obj.isSubmitted &&
        (Common.isEmptyUndef(SearchParm.Id) || Obj.id == SearchParm.Id) &&
        (SearchParm.hcfId == Obj.hfcId ||
          (SearchParm.hcfId == Obj.rhcId &&
            ((Obj.afbResult != null && Obj.afbResult != '') ||
              Obj.deliveryStatus > 3))) &&
        new Date(Common.ConvertToLocalDateTime(Obj.sampleDateTime)) >=
          SearchParm.fromDate &&
        new Date(Common.ConvertToLocalDateTime(Obj.sampleDateTime)) <=
          SearchParm.toDate
      )
    })
      .toArray()
      .then((Datalist) => {
        success_callback(Datalist)
      })
      .catch(function (e) {
        error_callback(e)
      })
  }
}
export function SelectPatientSample(id, success_callback, error_callback) {
  db.PatientSamples.get({ id: id })
    .then((obj) => {
      success_callback(obj)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
export function SelectReceivedPatientSamplesList(
  SearchParm,
  Pagination,
  success_callback,
  error_callback,
) {
  db.PatientSamples.filter(function (Obj) {
    return (
      Obj.isSubmitted &&
      SearchParm.xpertSiteId == Obj.xpertSiteId &&
      Obj.afbResult != null &&
      Obj.afbResult != '' &&
      (Obj.afbResult == 2 || Obj.isNegativeResultBypass == 1) &&
      (Common.isEmptyUndef(SearchParm.Id) || Obj.id == SearchParm.Id) &&
      Obj.deliveryStatus > Common.DeliveryStatus.PickedUp
    )
  })
    .toArray()
    .then((Datalist) => {
      success_callback(Datalist)
    })
    .catch(function (e) {
      error_callback(e)
    })
}
